import { schema } from 'normalizr';

import { processCurrentNetwork } from '../strategies/currentNetwork';

export const currentNetworkSchema = new schema.Entity('networks', {}, { processStrategy: processCurrentNetwork });
